import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Typography} from '@mui/material';

export default function ConfirmDialog({ open, onClose, onConfirm, title, msg, info = false, cancelTxt = 'Cancel', confirmTxt = 'Confirm' }) {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
      <Typography
        variant="body1"
        style={{ whiteSpace: "pre-line" }}
      >
        {msg}
      </Typography>
      </DialogContent>
      <DialogActions>
        {!info && (
          <Button onClick={onClose} color='secondary' variant='contained'>{cancelTxt}</Button>
        )}
        <Button onClick={onConfirm} variant='contained'>{confirmTxt}</Button>
      </DialogActions>
    </Dialog>
  );
}